var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.versions)?_c('b-table',{attrs:{"striped":"","thead-class":"d-none","items":_vm.assetVersionsMap,"fields":_vm.assetVersionsFields},scopedSlots:_vm._u([{key:"cell(action)",fn:function(data){return [_c('asset-version-row',{attrs:{"version":data.item}})]}}],null,false,938893744)}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }